// extracted by mini-css-extract-plugin
module.exports = {"button_close":"styles_button_close__2NPeo","button_close__close_icon":"styles_button_close__close_icon__2ugVc"};